import React, { useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import { motion as m, useAnimation, useInView } from "framer-motion";
import PageFrames from "../ui/pageframes";
import { services } from "../constants";
import ServiceCard from "../ui/servicecard";

const Services = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const mainControls = useAnimation();

  useEffect(() => {
    if (isInView) {
      mainControls.start("visible");
    }
  }, [isInView]);
  return (
    <PageFrames id="services">
      <div className="flex flex-col px-4 gap-2 items-center">
        <div className="flex flex-col md:flex-row items-center md:gap-4 text-[31px] text-center">
          <Icon icon="fluent-mdl2:c-r-m-services" className="text-[#002F6C]" />
          <h1>Our Services</h1>
        </div>
        <p className="accent-text text-center">
          We deliver reliable IT and security solutions tailored to your
          business needs.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:max-w-[70%] p-4">
        {services.map((service) => (
          <ServiceCard
            title={service.title}
            description={service.description}
            icon={service.icon}
          />
        ))}
      </div>
    </PageFrames>
  );
};

export default Services;
